import styled from '@emotion/styled';

export const HeaderWrap = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
`;

export const HeaderSectionWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;
